interface CSSObjectTypes {
  [cssProperty: string]: string;
}

interface ButtonStyleObjectTypes {
  [status: string]: CSSObjectTypes;
}

interface IconObjectTypes {
  [status: string]: string;
}

export const buttonStyleObject: ButtonStyleObjectTypes = {
  done: {
    backgroundColor: "rgba(22, 166, 101, 0.3)",
    color: "#16A665",
    border: "1.5px solid #16A665",
    paddingTop: "4px",
    paddingBottom: "4px",
    paddingLeft: "8px",
    paddingRight: "8px",
    borderRadius: "4px",
    fontWeight: "600",
    fontSize: "12px",
    display: "flex", // Use flexbox to align items in a single line
    textTransform: "capitalize",
  },
  error: {
    backgroundColor: "rgba(246, 62, 80, 0.3)",
    color: "#F63E50",
    border: "1.5px solid #F63E50",
    paddingTop: "4px",
    paddingBottom: "4px",
    paddingLeft: "8px",
    paddingRight: "8px",
    borderRadius: "4px",
    fontWeight: "600",
    fontSize: "12px",
    textTransform: "capitalize",
    display: "flex", // Use flexbox to align items in a single line
  },
};

export const buttonDefaultStyle: CSSObjectTypes = {
  backgroundColor: "rgba(255, 255, 0, 0.1)",
  color: "#FFBF00",
  border: "1.5px solid #FFBF00",
  paddingTop: "8px",
  paddingBottom: "8px",
  paddingLeft: "8px",
  paddingRight: "8px",
  borderRadius: "4px",
  fontWeight: "600",
  fontSize: "10px",
  textTransform: "capitalize",
  display: "flex", //
};

export const iconObject: IconObjectTypes = {
  done: "./assets/icons/tick.svg",
  error: "./assets/icons/error.svg",
};

export const golfColumsArray: any = [
  {
    title: "ID",
    dataIndex: "index",
    key: "index",
    width: "3%",
    render: (text: any, record: any, index: number) => {
      return index < 9 ? `0${index + 1}` : index + 1;
    },
    responsive: ["xl"], // visible for all
    //   responsive: ['xs', 'sm', 'md', 'lg'], // visible for all
  },
  {
    title: "Timestamp",
    dataIndex: "dateTime",
    key: "dateTime",
    width: "7%",
  },
  {
    title: "Uploaded By",
    dataIndex: "uploader",
    key: "uploader",
    width: "14%",
  },
  {
    title: "Video Name",
    dataIndex: "videoName",
    key: "videoName",
    width: "15%",
  },
  {
    title: "Role",
    dataIndex: "userRole",
    key: "userRole",
    width: "4%",
    responsive: ["xl"], // visible for all
  },
  {
    title: "Device Type",
    dataIndex: "deviceType",
    key: "deviceType",
    width: "6%",
    align: "center",
  },
  {
    title: "Orientation",
    dataIndex: "orientation",
    key: "orientation",
    width: "6%",
    align: "center",
    responsive: ["xl"], // visible for all
  },
  {
    title: "Swing Type",
    dataIndex: "swingType",
    key: "swingType",
    width: "5%",
    align: "center", // Align center for this column
  },
  {
    title: "Processing Time",
    dataIndex: "totalProcessing",
    key: "totalProcessing",
    width: "6%",
    align: "center", // Align center for this column
    responsive: ["xl"], // visible for all
  },
  {
    title: "Pose Server",
    dataIndex: "poseServer",
    key: "poseServer",
    width: "7%",
    align: "center", // Align center for this column
    responsive: ["xl"], // visible for all
  },
  {
    title: "Pose Status",
    dataIndex: "poseStatus",
    key: "poseStatus",
    width: "7%",
    align: "center", // Align center for this column
    // render: displayStatus,
    responsive: ["xl"], // visible for all
  },
  {
    title: "Club Server",
    dataIndex: "clubServer",
    key: "clubServer",
    width: "7%",
    align: "center",
    // Align center for this column
    responsive: ["xl"], // visible for all
  },
  {
    title: "Club Status",
    dataIndex: "clubStatus",
    key: "currentStatus",
    width: "7%",
    align: "center", // Align center for this column
    // render: displayStatus,
    responsive: ["xl"], // visible for all
  },
  {
    title: "Action",
    dataIndex: "preview",
    key: "preview",
    align: "center", // Align center for this column
    width: "7%",
    fixed: "right",
    // render: displayAction,
  },
];

export const columnsLaunchArray: any = [
  {
    title: "ID",
    dataIndex: "index",
    key: "index",
    width: "4%",
    render: (text: any, record: any, index: number) => {
      return index < 9 ? `0${index + 1}` : index + 1;
    },
    responsive: ["xl"],
  },
  {
    title: "Timestamp",
    dataIndex: "dateTime",
    key: "dateTime",
    width: "10%",
  },
  {
    title: "Uploaded By",
    dataIndex: "uploader",
    key: "uploader",
    width: "15%",
  },
  {
    title: "Video Name",
    dataIndex: "videoName",
    key: "videoName",
    width: "15%",
  },
  {
    title: "Role",
    dataIndex: "userRole",
    key: "userRole",
    width: "5%",
    responsive: ["xl"],
  },
  {
    title: "Device Type",
    dataIndex: "deviceType",
    key: "deviceType",
    width: "7%",
    align: "center",
  },
  {
    title: "Processing Time",
    dataIndex: "totalProcessing",
    key: "totalProcessing",
    width: "10%",
    align: "center", // Align center for this column
    responsive: ["xl"],
  },

  {
    title: "Club Server",
    dataIndex: "clubServer",
    key: "clubServer",
    width: "8%",
    align: "center",
    responsive: ["xl"],
    // Align center for this column
  },
  {
    title: "Processing Status",
    dataIndex: "clubStatus",
    key: "currentStatus",
    width: "8%",
    align: "center", // Align center for this column
    // render: displayStatus,
    responsive: ["xl"],
  },
  {
    title: "Launch Data",
    dataIndex: "launchDataStatus",
    key: "launchDataStatus",
    width: "8%",
    align: "center", // Align center for this column
    // render: displayStatus,
    responsive: ["xl"],
  },
  {
    title: "Action",
    dataIndex: "preview",
    key: "preview",
    align: "center", // Align center for this column
    width: "10%",
    // render: displayAction,
  },
];

export const columnsAthleticsArray: any = [
  {
    title: "ID",
    dataIndex: "index",
    key: "index",
    width: "5%",
    render: (text: any, record: any, index: number) => {
      return index < 9 ? `0${index + 1}` : index + 1;
    },
    responsive: ["lg"],
  },
  {
    title: "Timestamp",
    dataIndex: "dateTime",
    key: "dateTime",
    width: "15%",
    responsive: ["lg"],
  },
  {
    title: "Uploaded By",
    dataIndex: "uploader",
    key: "uploader",
    width: "15%",
  },
  {
    title: "Video Name",
    dataIndex: "videoName",
    key: "videoName",
    width: "15%",
  },
  {
    title: "Role",
    dataIndex: "userRole",
    key: "userRole",
    width: "10%",
    responsive: ["lg"],
  },
  {
    title: "Device Type",
    dataIndex: "deviceType",
    key: "deviceType",
    width: "10%",
    align: "center",
  },
  {
    title: "Processing Time",
    dataIndex: "totalProcessing",
    key: "totalProcessing",
    width: "9%",
    align: "center", // Align center for this column
    responsive: ["lg"],
  },

  {
    title: "Pose Server",
    dataIndex: "poseServer",
    key: "poseServer",
    width: "8%",
    align: "center",
    // Align center for this column
    responsive: ["lg"],
  },
  {
    title: "Processing Status",
    dataIndex: "poseStatus",
    key: "poseStatus",
    width: "8%",
    align: "center",
    responsive: ["lg"],
    // render: displayStatus,
  },

  {
    title: "Action",
    dataIndex: "preview",
    key: "preview",
    align: "center", // Align center for this column
    width: "5%",
    // render: displayAction,
  },
];

export const columnsSimulationArray: any = [
  {
    title: "ID",
    dataIndex: "index",
    key: "index",
    width: "5%",
    render: (text: any, record: any, index: number) => {
      return index < 9 ? `0${index + 1}` : index + 1;
    },
  },
  {
    title: "Timestamp",
    dataIndex: "dateTime",
    key: "dateTime",
    width: "9%",
  },
  {
    title: "Uploaded By",
    dataIndex: "uploader",
    key: "uploader",
    width: "15%",
  },
  {
    title: "Video Name",
    dataIndex: "videoName",
    key: "videoName",
    width: "16%",
  },
  // {
  //   title: "Sport Name",
  //   dataIndex: "sportName",
  //   key: "sportName",
  //   width: "7%",
  //   align: "center",
  // },
  {
    title: "Movement Type",
    dataIndex: "movementType",
    key: "movementType",
    width: "8%",
    align: "center",
  },
  {
    title: "Device Type",
    dataIndex: "deviceType",
    key: "deviceType",
    width: "7%",
    align: "center",
  },
  {
    title: "User Orientation",
    dataIndex: "deviceAngle",
    key: "deviceAngle",
    width: "9%",
    align: "center",
  },
  {
    title: "Processing Time",
    dataIndex: "totalProcessing",
    key: "totalProcessing",
    width: "8%",
    align: "center",
  },

  {
    title: "Processing Status",
    dataIndex: "processingStatus",
    key: "processingStatus",
    width: "9%",
    align: "center",
    // render: displayStatus,
  },

  {
    title: "Action",
    dataIndex: "preview",
    key: "preview",
    align: "center", // Align center for this column
    width: "7%",
    // render: displayAction,
  },
];
export const columnsTonalSimulationArray: any = [
  {
    title: "ID",
    dataIndex: "index",
    key: "index",
    width: "5%",
    render: (text: any, record: any, index: number) => {
      return index < 9 ? `0${index + 1}` : index + 1;
    },
  },
  {
    title: "Timestamp",
    dataIndex: "dateTime",
    key: "dateTime",
    width: "9%",
  },
  {
    title: "Video Name",
    dataIndex: "videoName",
    key: "videoName",
    width: "16%",
  },
  {
    title: "Processing Status",
    dataIndex: "processingStatus",
    key: "processingStatus",
    width: "9%",
    align: "center",
    // render: displayStatus,
  },

  {
    title: "Action",
    dataIndex: "preview",
    key: "preview",
    align: "center", // Align center for this column
    width: "7%",
    // render: displayAction,
  },
];

export const columnsUserHistoryArray: any = [
  {
    title: "ID",
    dataIndex: "index",
    key: "index",
    width: "5%",
    render: (text: any, record: any, index: number) => {
      return index < 9 ? `0${index + 1}` : index + 1;
    },
  },
  {
    title: "Timestamp",
    dataIndex: "dateTime",
    key: "dateTime",
    width: "9%",
  },
  {
    title: "Uploaded By",
    dataIndex: "uploader",
    key: "uploader",
    width: "15%",
  },
  {
    title: "Video Name",
    dataIndex: "videoName",
    key: "videoName",
    width: "16%",
  },
  {
    title: "Sport Name",
    dataIndex: "sportName",
    key: "sportName",
    width: "7%",
    align: "center",
  },
  {
    title: "Swing Type",
    dataIndex: "swingType",
    key: "swingType",
    width: "8%",
    align: "center",
  },
  {
    title: "Device Type",
    dataIndex: "deviceType",
    key: "deviceType",
    width: "7%",
    align: "center",
  },
  {
    title: "User Orientation",
    dataIndex: "orientation",
    key: "orientation",
    width: "9%",
    align: "center",
  },
  {
    title: "Processing Time",
    dataIndex: "totalProcessing",
    key: "totalProcessing",
    width: "8%",
    align: "center",
  },

  {
    title: "Processing Status",
    dataIndex: "processingStatus",
    key: "processingStatus",
    width: "9%",
    align: "center",
    // render: displayStatus,
  },

  {
    title: "Action",
    dataIndex: "preview",
    key: "preview",
    align: "center", // Align center for this column
    width: "7%",
    // render: displayAction,
  },
];

export const columnsUserHistoryArrayBaseball: any = [
  {
    title: "ID",
    dataIndex: "index",
    key: "index",
    width: "5%",
    render: (text: any, record: any, index: number) => {
      return index < 9 ? `0${index + 1}` : index + 1;
    },
  },
  {
    title: "Timestamp",
    dataIndex: "dateTime",
    key: "dateTime",
    width: "9%",
  },
  {
    title: "Uploaded By",
    dataIndex: "uploader",
    key: "uploader",
    width: "15%",
  },
  {
    title: "Video Name",
    dataIndex: "videoName",
    key: "videoName",
    width: "16%",
  },
  {
    title: "Sport Name",
    dataIndex: "sportName",
    key: "sportName",
    width: "7%",
    align: "center",
  },
  {
    title: "Movement Type",
    dataIndex: "movementType",
    key: "movementType",
    width: "8%",
    align: "center",
  },
  {
    title: "Device Type",
    dataIndex: "deviceType",
    key: "deviceType",
    width: "7%",
    align: "center",
  },
  {
    title: "User Orientation",
    dataIndex: "orientation",
    key: "orientation",
    width: "9%",
    align: "center",
  },
  {
    title: "Processing Time",
    dataIndex: "totalProcessing",
    key: "totalProcessing",
    width: "8%",
    align: "center",
  },

  {
    title: "Processing Status",
    dataIndex: "processingStatus",
    key: "processingStatus",
    width: "9%",
    align: "center",
    // render: displayStatus,
  },

  {
    title: "Action",
    dataIndex: "preview",
    key: "preview",
    align: "center", // Align center for this column
    width: "7%",
    // render: displayAction,
  },
];

export const columnsUserHistoryArrayAthletics: any = [
  {
    title: "ID",
    dataIndex: "index",
    key: "index",
    width: "5%",
    render: (text: any, record: any, index: number) => {
      return index < 9 ? `0${index + 1}` : index + 1;
    },
  },
  {
    title: "Timestamp",
    dataIndex: "dateTime",
    key: "dateTime",
    width: "9%",
  },
  {
    title: "Uploaded By",
    dataIndex: "uploader",
    key: "uploader",
    width: "15%",
  },
  {
    title: "Video Name",
    dataIndex: "videoName",
    key: "videoName",
    width: "16%",
  },
  {
    title: "Sport Name",
    dataIndex: "sportName",
    key: "sportName",
    width: "7%",
    align: "center",
  },
  {
    title: "Exercise Type",
    dataIndex: "exerciseType",
    key: "exerciseType",
    width: "8%",
    align: "center",
  },
  {
    title: "Device Type",
    dataIndex: "deviceType",
    key: "deviceType",
    width: "7%",
    align: "center",
  },
  {
    title: "User Orientation",
    dataIndex: "orientation",
    key: "orientation",
    width: "9%",
    align: "center",
  },
  {
    title: "Processing Time",
    dataIndex: "totalProcessing",
    key: "totalProcessing",
    width: "8%",
    align: "center",
  },

  {
    title: "Processing Status",
    dataIndex: "processingStatus",
    key: "processingStatus",
    width: "9%",
    align: "center",
    // render: displayStatus,
  },

  {
    title: "Action",
    dataIndex: "preview",
    key: "preview",
    align: "center", // Align center for this column
    width: "7%",
    // render: displayAction,
  },
];

export const historyStatusObj: { [pathname: string]: string[] } = {
  "/m2c-golf-history": ["Pose Status", "Club Status"],
  "/m2c-launch-history": ["Processing Status", "Launch Data"],
  "/m2c-athletics-history": ["Processing Status"],
  "/simulation-history": ["Processing Status"],
  "/tonal-history": ["Processing Status"],
  "/user-history": ["Processing Status"],
};
